// extracted by mini-css-extract-plugin
module.exports = {"modalComponentWrapper":"PanelModal_modalComponentWrapper__KD_7S","panelModalContent":"PanelModal_panelModalContent____T4T"};